// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__thLxy","heart":"Footer_heart__2S-ZN"};